import React from "react";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import SvgIcon from "connectui/component/display/SvgIcon";
import ICONS from "connectui/icons/iconMap";
import Text from "connectui/component/display/Text";
import {gradientRgb} from "utilities/helperFunctions";

const useStyles = (theme) =>
  buildStyles({
    icon: {
      width: "20px",
      height: "20px",
      border: `1px solid ${theme.colors.white}`,
      borderRadius: "50%",
    },
    label: {
      textTransform: "capitalize",
      backgroundColor: gradientRgb(theme.colors.gray800, 0.8),
      padding: theme.spacing(0.5, 2),
      borderRadius: `${theme.radius.sm}px`,
    },
  });

const channelIcons = {
  VRBO: "vrbo-circle",
  Airbnb: "airbnb-circle",
  Expedia: "expedia-circle",
  Google: "google-circle",
  "Booking.com": "bookingcom-circle",
  "Home Away": "homeaway-circle",
};

const BookingChannelIcon = ({channel = null}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);

  if (!channel) {
    return null;
  }
  return (
    <FlexContainer className={classes.container}>
      {channelIcons[channel] ? (
        <SvgIcon
          component={ICONS[channelIcons[channel]]}
          className={classes.icon}
        />
      ) : (
        <Text
          variant="textXS"
          weight="medium"
          color="white"
          className={classes.label}
        >
          {channel}
        </Text>
      )}
    </FlexContainer>
  );
};

export default BookingChannelIcon;
